export default {
  about_us: 'About Us',
  alphabet_az: 'Title A-Z',
  alphabet_za: 'Title Z-A',
  back: 'Back',
  compare: 'Compare',
  compare_helper: 'Please enter the model name or part of it.',
  comparison: 'Comparison',
  contact_us: 'Contact',
  copyright: 'Copyright &copy; {year} {sitename}. All rights reserved.',
  dashboard: 'Dashboard',
  find_laptop: 'Find laptop',
  finder: 'Finder',
  finder_result: 'Finder Result',
  highest_price: 'Highest Price',
  home: 'Home',
  laptop_finder: 'Laptop Finder',
  laptops_type: '{title} Laptops',
  last_modified: 'Last modified',
  latest: 'Latest',
  latest_comparison: 'Latest Comparison',
  login: 'Login',
  login_signup: 'Login/Signup',
  logout: 'Logout',
  lowest_price: 'Lowest Price',
  news: 'News',
  oldest: 'Oldest',
  popular_comparison: 'Popular Comparison',
  price: 'Price',
  privacy_policies: 'Privacy Policies',
  product_title: '{name} complete specification',
  products: 'Products',
  see_all: 'See all',
  show_all: 'Show all',
  submit: 'Submit',
  sort: 'Sort',
  sort_by: 'Sort by',
  terms_conditions: 'Terms & Conditions',
  types: 'Types',
  wishlist: 'Wishlist',
};
